import NoPageFound from 'pages/common/pageNotFound';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MyProjects from './pages/myProjects';
import Taskboard from './pages/taskBoard';
import TaskBoardPage from './pages/taskBoard/components/taskBoardPage';

export default function Projects() {
  return (
    <Routes>
      <Route path='my-projects' element={<MyProjects />} />
      <Route path='task-board' element={<Taskboard />} />
      <Route path='task-board/:id' element={<TaskBoardPage />} />

      {/* empty page when route not found */}
      <Route path='*' element={<NoPageFound />} />
    </Routes>
  );
}
